import { render, staticRenderFns } from "./InternalRemarks.vue?vue&type=template&id=987da9d2&"
import script from "./InternalRemarks.vue?vue&type=script&lang=js&"
export * from "./InternalRemarks.vue?vue&type=script&lang=js&"
import style0 from "./InternalRemarks.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports